import React from 'react';
import { titleCase } from 'title-case';
import SliderPercentage from '../../../../../../../components/ui/SliderPercentage';
import settingsStyles from '../../../../Components/ModalSettings/ModalSettings.module.scss';
import styles from './width.module.scss';

const Width = ({ width, setWidth, setChange }) => (
  <div className={styles.wrapper}>
    <div className={settingsStyles.title}>{titleCase('Width')}</div>
    <div className={styles.slider}>
      <SliderPercentage
        value={width}
        setValue={setWidth}
        setChange={setChange}
      />
    </div>
  </div>
);

export default Width;
